import { Drawer, IconButton, List } from "@material-ui/core";
import { ArrowBack as ArrowBackIcon } from "@material-ui/icons";
import { useTheme } from "@material-ui/styles";
import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import useStyles from "./styles";
import {
  toggleSidebar,
  useLayoutDispatch,
  useLayoutState,
} from "../../context/LayoutContext";
import SuperAdminSidebar from "./categories/SuperAdminSidebar";
import AdminSidebar from "./categories/AdminSidebar";
import RecruiterSidebar from "./categories/RecruiterSidebar";
import HiringManagerSidebar from "./categories/HiringManagerSidebar";
import FreelancerSidebar from "./categories/FreelancerSidebar";
import { ChatSidebar, ShareSidebar } from "./categories/ExtraSidebars";
import VendorSidebar from "./categories/VendorSidebar";
import EmployeeSidebar from "./categories/EmployeeSidebar";

function Sidebar({ location }) {
  const classes = useStyles();
  const theme = useTheme();
  const token = localStorage.getItem("token");
  const decode = jwtDecode(token);
  const role = decode.role;

  // global
  const { isSidebarOpened } = useLayoutState();
  const layoutDispatch = useLayoutDispatch();
  const [isPermanent, setPermanent] = useState(true);

  useEffect(function () {
    window.addEventListener("resize", handleWindowWidthChange);
    handleWindowWidthChange();
    return function cleanup() {
      window.removeEventListener("resize", handleWindowWidthChange);
    };
  });

  return (
    <Drawer
      variant={isPermanent ? "permanent" : "temporary"}
      className={classNames(classes.drawer, {
        [classes.drawerOpen]: isSidebarOpened,
        [classes.drawerClose]: !isSidebarOpened,
      })}
      classes={{
        paper: classNames({
          [classes.drawerOpen]: isSidebarOpened,
          [classes.drawerClose]: !isSidebarOpened,
        }),
      }}
      open={isSidebarOpened}
      onClose={() => toggleSidebar(layoutDispatch)}
    >
      <div className={classes.mobileBackButton}>
        <IconButton onClick={() => toggleSidebar(layoutDispatch)}>
          <ArrowBackIcon
            classes={{
              root: classNames(classes.headerIcon, classes.headerIconCollapse),
            }}
          />
        </IconButton>
      </div>
      <List className={classes.sidebarList}>
        <>
          {location.pathname !== "/app/singlechat" &&
          location.pathname !== "/shortList" ? (
            <>
              {role === "SUPERADMIN" ? (
                <SuperAdminSidebar
                  location={location}
                  isSidebarOpened={isSidebarOpened}
                />
              ) : role === "ADMIN" ? (
                <AdminSidebar
                  location={location}
                  isSidebarOpened={isSidebarOpened}
                />
              ) : role === "RECRUITER" ? (
                <RecruiterSidebar
                  location={location}
                  isSidebarOpened={isSidebarOpened}
                />
              ) : role === "CLIENTCOORDINATOR" ? (
                <HiringManagerSidebar
                  location={location}
                  isSidebarOpened={isSidebarOpened}
                />
              ) : role === "SUBVENDOR" ? (
                <FreelancerSidebar
                  location={location}
                  isSidebarOpened={isSidebarOpened}
                />
              ) : role === "SUBCONTRACT" ? (
                <VendorSidebar
                  location={location}
                  isSidebarOpened={isSidebarOpened}
                />
              ) : (
                <EmployeeSidebar
                  location={location}
                  isSidebarOpened={isSidebarOpened}
                />
              )}
            </>
          ) : location.pathname === "/shortList" ? (
            <ShareSidebar
              location={location}
              isSidebarOpened={isSidebarOpened}
            />
          ) : (
            <ChatSidebar
              location={location}
              isSidebarOpened={isSidebarOpened}
            />
          )}
        </>
      </List>
    </Drawer>
  );

  // ##################################################################
  function handleWindowWidthChange() {
    const windowWidth = window.innerWidth;
    const breakpointWidth = theme.breakpoints.values.sm;
    const isSmallScreen = windowWidth < breakpointWidth;

    if (isSmallScreen && isPermanent) {
      setPermanent(false);
    } else if (!isSmallScreen && !isPermanent) {
      setPermanent(true);
    }
  }
}

export default withRouter(Sidebar);
